module.exports = __webpack_public_path__ + "static/media/report_11-15_desktop.f499c80e.png";